import React from 'react';

import PageLayout from 'pages/CourseDashboard/Password/PageLayout';

const PasswordCourseDashboard = () => {
    return <PageLayout />;
};

export default PasswordCourseDashboard;
